﻿dateConverter = (function() {
    var toDateTrimmed = function(text) {
        return kendo.parseExactDate(text, "dd-MM-yyyy");
    };

    var toDate = function(text) {
        return toDateTrimmed(text ? text.trim() : null);
    };

    var isValid = function(text) {
        return toDate(text) !== null;
    };

    var isNullOrValid = function(text) {
        if (text !== null) {
            var s = text.trim();
            return (s === "") || (toDateTrimmed(s) !== null);
        }
        return true;
    };

    var toString = function(value) {
        return kendo.toString(value, "dd-MM-yyyy")
    }

    return {
        isValid: isValid,
        isNullOrValid: isNullOrValid,
        toDate: toDate,
        toString: toString
    };
})();
